import React, { useEffect, useState, useContext } from "react";
import { Paper, Box, Grid, Avatar, Chip, Switch, FormControlLabel, Typography, InputAdornment, CircularProgress, MenuItem, TextField, IconButton } from '@mui/material';
import { DndContext, closestCenter, DragOverlay, PointerSensor, useSensor, useSensors, } from "@dnd-kit/core";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import { SortableItem, DroppableColumn } from "./TicketData";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import ApiService from '../../functions/apiService';
import { toast } from 'react-toastify';
import moment from "moment";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AuthContext from "../../context/AuthContext";
import TicketModal from "./TicketModal";
import Modal from 'react-bootstrap/Modal';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Row , Col } from "react-bootstrap";

const transformData = (apiData) => {
  const statusMap = {
    todo: "todo",
    progress: "progress",
    // review: "review",
    completed: "completed",
    cancelled: "cancelled"
  };

  const columns = {
    todo: { name: "To Do", items: [] },
    progress: { name: "Progress", items: [] },
    // review: { name: "Review", items: [] },
    completed: { name: "Completed", items: [] },
    cancelled: { name: "Cancelled", items: [] }
  };

  apiData.map((ticket) => {
    const statusKey = statusMap[ticket.tickteting_status?.status] || "todo";

    if (columns[statusKey]) {
      columns[statusKey].items.push({
        id: String(ticket.id),
        content: ticket.title,
        description: ticket.description,
        employee_first_name: ticket.employee_first_name,
        employee_last_name: ticket.employee_last_name,
        date: ticket.updated_at,
        image: ticket.image,
				employee_code: ticket.employee_code,
				secondaryImage : ticket.secondary_image,
				Assigned_by : ticket.assignee,
				ticket_type : ticket?.ticket_type
      });
    }
  });

  return columns;
};

const Ticketing = () => {
	const { user } = useContext(AuthContext);
  const [activeItem, setActiveItem] = useState(null);
  const [viewType, setViewType] = useState("card");
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setfilter] = useState(1);
  const [data, setdata] = useState([]);
  const [ticketType, setTicketType] = useState('myTicket');
  const [myCount, setMyCount] = useState('');
  const [allCount, setAllCount] = useState('');
	const [show, setShow] = useState(false);
	const [ticketData, setTicketData] = useState('')
  const ITEMS_PER_PAGE = 10;
  const limit = 50;
  const titleLimit = 23;

  const [columns, setColumns] = useState({
    todo: { name: "To Do", items: [] },
    inProgress: { name: "Progress", items: [] },
    // review: { name: "Review", items: [] },
    completed: { name: "Completed", items: [] },
    cancelled: { name: "Cancelled", items: [] }
  });

  const columnsTable = [
    {
      field: 'updated_at',
      headerName: 'Date',
      width: 200,
      renderCell: (params) => 
				<>
					{moment(params.updated_at).format('MM/DD/YYYY')}
					{params?.row?.employee_code == user?.Emp_Code && ticketType == 'allTicket' &&
						<Chip style={{ width: '80px', marginLeft: '18px' }}
								color={'DarkGreen'}
								label={'My Ticket'}
						/>}
				</>
    },
    {
      field: 'employee_full_name',
      headerName: 'Assigned by',
      width: 230,
      editable: true,
			valueGetter: (params) => {
				return (params?.row?.assignee_employee_first_name + " " + params?.row?.assignee_employee_last_name);
      },
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 320,
      editable: true,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            lineHeight: '1.4',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: 'image',
      headerName: 'Image',
      sortable: false,
      width: 160,
      renderCell: (params) => (
        <a
          href={params.value}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block' }}
        >
          <img
            src={params.value ? params.value : 'No image'}
            alt="No Image"
            style={{
              width: '40px',
              height: '40px',
              objectFit: 'cover',
              borderRadius: '50px',
              cursor: 'pointer',
            }}
          />
        </a>
      ),
    },

    {
      field: 'status',
      headerName: 'Status',
      sortable: true,
      width: 160,
      valueGetter: (params) => {
        return params.row.tickteting_status?.id == 1 ? "To Do" 
				: params.row.tickteting_status?.id == 2 ? "Progress"
				: params.row.tickteting_status?.id == 4 ? "Completed"
				: params.row.tickteting_status?.id == 4 ? "Cancelled"
				: 'N/A';
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      width: 110,
      renderCell: (params) => (
        <div>
          <IconButton
            color="secondary"
            size="small"
          >
            <VisibilityOutlinedIcon
							onClick={() =>{
								setTicketData(params?.row) 
								setShow(true)}
							} />
          </IconButton>
        </div>
      ),
    }
  ];

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    })
  );

  const TicketData = () => {
    const body = {
      "type" : ticketType
    }
    ApiService.post('/tickets/checklists/show-ticket', body)
		.then((data) => {
			setMyCount(data?.data?.counts?.my_ticket_count)
			setAllCount(data?.data?.counts?.all_ticket_count)
      const transformedColumns = transformData(data.data?.tickets);
      setColumns(transformedColumns);
      setdata(data.data?.tickets)
    }).catch((error) => {
			console.error("error", error)
      toast.error(error);
    })
  };

  useEffect(() => {
    TicketData()
  }, [ticketType])

  const onDragStart = (event) => {
    const { active } = event;
    if (active) {
      const item = Object.values(columns)
        .flatMap((col) => col.items)
        .find((item) => item.id === active.id);
      setActiveItem(item);
    }
  };

  const statusMapping = {
    todo: 1,
    progress: 2,
    // review: 3,
    completed: 4,
    cancelled: 5
  };

  const onDragEnd = (event) => {
    const { active, over } = event;
    setActiveItem(null);

    if (!over) return;

    const sourceColId = Object.keys(columns).find((key) =>
      columns[key].items.some((item) => item.id === active.id)
    );

    if (!sourceColId) return;

    let destColId =
      Object.keys(columns).find((key) =>
        columns[key].items.some((item) => item.id === over.id)
      ) || over.id;

    if (!columns[destColId]) return;

    const newStatus = statusMapping[destColId];

    if (newStatus === undefined) {
      console.error("Invalid destination column ID:", destColId);
      return;
    }

    if (sourceColId === destColId) {
      const newItems = arrayMove(
        columns[sourceColId].items,
        columns[sourceColId].items.findIndex((item) => item.id === active.id),
        columns[sourceColId].items.findIndex((item) => item.id === over.id)
      );

      setColumns((prev) => ({
        ...prev,
        [sourceColId]: { ...prev[sourceColId], items: newItems },
      }));
    } else {
      const sourceItems = [...columns[sourceColId].items];
      const destItems = [...columns[destColId].items];
      const [movedItem] = sourceItems.splice(
        sourceItems.findIndex((item) => item.id === active.id),
        1
      );

      destItems.push(movedItem);

      setColumns((prev) => ({
        ...prev,
        [sourceColId]: { ...prev[sourceColId], items: sourceItems },
        [destColId]: { ...prev[destColId], items: destItems },
      }));

      handleTicketStatus(active.id, newStatus);
    }
  };

  const handleTicketStatus = (ticketId, newStatus) => {
    const body = {
      checklist_ticket_id: ticketId,
      status: newStatus,
    };

    ApiService.post('/tickets/checklists/update-status', body)
      .then((response) => {
        toast.success(response.message);
        // const transformedColumns = transformData(response.data);
        // setColumns(transformedColumns);
      })
      .catch((error) => {
        toast.error(error?.data?.message);
				setTimeout(()=> window?.location?.reload(), 3000)
      });
  };

  const paginatedData = data.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);


  return (
		<>
    <Paper className="p-4 font-fam" style={{ marginTop: "1rem", padding: "1rem" }}>
      <Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px", marginBottom: '30px' }} >
        <Grid item xs={12} md={3}>
          <Typography variant="h5">Ticketing</Typography>
        </Grid>

				<Grid container item md={4} gap={1}>
        <Grid item xs={6} sm={12} md={5}>
				<div 
				className={ticketType == 'myTicket' ? 'tab-active' : 'tab-white'}
					style={{
						width: '150px'
					}}
					onClick={() => {
						setTicketType('myTicket')
					}}>
					{`My Tickets (${myCount || 0})`}
					{/* {'My Tickets'} */}
				</div>
				</Grid>

        <Grid item xs={6} sm={12} md={5}>
				<div 
				className={ticketType == 'allTicket' ? 'tab-active' : 'tab-white'}
					style={{
						width: '150px'
					}}
					onClick={() => {
						setTicketType('allTicket')
					}}>
					{`All Tickets (${allCount || 0})`}
					{/* {'All Tickets'} */}
				</div>
				</Grid>
				</Grid>

        <Grid item xs={6} sm={12} md={1}>
          <div
            style={{
              height: "48px",
              border: "1px solid #EAECF0",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "48px",
                height: "48px",
                cursor: "pointer",
                borderRight: "1px solid #EAECF0",
              }}
              onClick={() => setViewType("card")}
            >
              <img
                src={viewType === "list" ? "/images/card-empty.svg" : "/images/card.svg"}
                height="22px"
                width="22px"
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "48px",
                height: "48px",
                cursor: "pointer",
              }}
              onClick={() => setViewType("list")}
            >
              <img
                src={viewType === "list" ? "/images/listview.svg" : "/images/list-empty.svg"}
                height="20px"
                width="20px"
              />
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
          <TextField
            variant="outlined"
            placeholder="Search from title"
            className="w-100"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
              sx: {
                height: '48px',
                fontSize: '14px',
                marginRight: '10px',
              },
            }}
          />
        </Grid>
      </Grid>

      {viewType == 'card' &&
        <DndContext
          collisionDetection={closestCenter}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          sensors={sensors}
        >

          <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none' }}>
            <Grid container spacing={2} wrap="nowrap">
              {Object.entries(columns).map(([columnId, column]) => (
                <Grid item xs={4} key={columnId} style={{ minWidth: '300px' }}>
                  <DroppableColumn columnId={columnId} column={column}>
                    <SortableContext items={column.items.map((item) => item.id)}>
                      {column.items.map((item) => (
                        <SortableItem 
													key={item.id} 
													item={item} 
													activeItem={activeItem} 
													ticketApi={TicketData} 
													ticketType={ticketType} 
												/>
                      ))}
                    </SortableContext>
                  </DroppableColumn>
                </Grid>
              ))}
            </Grid>
          </div>


          <DragOverlay>
            {activeItem ? (
              <Box
                sx={{
                  padding: "16px",
									marginBottom: "16px",
									backgroundColor: "white",
									borderRadius: "8px",
									boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
									cursor: "grab",
									maxWidth: "100%",
                }}
              >
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<Typography fontWeight={600}>{activeItem?.content || 'No Title'}</Typography>
									<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
										<u style={{ fontSize: '14px', cursor: 'pointer', color: '#D92D20' }}>Details →</u>
									</div>
								</div>
				
								<div style={{height:'1px' , backgroundColor:'#EAECF0' , marginTop:'10px'}}></div>
				
								<div style={{ marginTop: '10px' }}>
									<Typography sx={{ fontSize: '14px', color: '#777777' }}>
										{activeItem?.description ? `${activeItem.description.substring(0, limit)}...` : " "}
									</Typography>
				
									<Typography sx={{ fontSize: '14px', marginTop: '8px' }}>
										<strong>Assigned to :</strong> {activeItem?.employee_first_name} {activeItem?.employee_last_name}
									</Typography>
				
									<Typography sx={{ fontSize: '14px', marginBottom: '8px' }}>
										<strong>Date:</strong> {moment(activeItem.date).format('DD//MM/YYYY')}
									</Typography>
				
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
										{activeItem?.employee_code == user?.Emp_Code && ticketType === 'allTicket' && (
											<div style={{ background: '#ECFDF3', color: '#12B76A', fontSize: '12px', borderRadius: '16px', padding: '2px 10px' }}>
												My Ticket
											</div>
										)}
				
										<div style={{ display: 'flex', alignItems: 'center', gap: '6px' , cursor:'pointer' , marginTop:'10px' }}>
											{activeItem?.employee_code == user?.Emp_Code &&
												<EditIcon sx={{ height: '20px', width: '20px', color: '#555555' , cursor:'pointer' }} />
											}
											{activeItem?.employee_code == user?.Emp_Code &&
												<DeleteIcon sx={{ height: '20px', width: '20px', color: '#555555' , cursor:'pointer'}} />
											}
											{activeItem.image && (
												<div style={{ textAlign: 'right', marginLeft:'4px' }}>
													<a href={activeItem.image} target="_blank" rel="noopener noreferrer">
														<img
															src={activeItem.image}
															height="24px"
															width="24px"
															style={{
																borderRadius: '50%',
																border: '1px solid #777777',
																cursor: 'pointer',
															}}
														/>
													</a>
												</div>
											)}

											{activeItem.secondaryImage	 && (
												<div style={{ textAlign: 'right', marginLeft:'4px' }}>
													<a href={activeItem.secondaryImage} target="_blank" rel="noopener noreferrer">
														<img
															src={activeItem.secondaryImage}
															height="24px"
															width="24px"
															style={{
																borderRadius: '50%',
																border: '1px solid #cccccc',
																cursor: 'pointer',
															}}
														/>
													</a>
												</div>
											)}

											<div className="mx-2">
												<img src="/images/download-pdf.svg" width='20px' height= '20px' />
											</div>
										</div>
									</div>
								</div>
              </Box>
            ) : null}
          </DragOverlay>
        </DndContext>
      }

      {viewType == 'list' &&
        <>
          {paginatedData.length === 0 &&
						<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 495, width: "100%" }}>
								<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
								<span className='mt-4' style={{ color: '#555555' }}>
									No Tickets Found
								</span>
							</div>
          }
          {paginatedData.length > 0 &&
            <Box sx={{ width: '100%' }}>
              <DataGrid
                rows={paginatedData}
                columns={columnsTable}
                getRowHeight={() => 72}
                hideFooter
                disableRowSelectionOnClick
                sx={{
                  '& .MuiDataGrid-row': {
                    borderBottom: 'none',
                  },
                }}
              />
            </Box>
          }

          <Pagination
            count={totalPages}
            color="primary"
            className="mt-3 mb-3 d-flex"
            style={{ justifyContent: 'end' }}
            page={currentPage}
            onChange={(event, page) => setCurrentPage(page)}
          />
        </>
      }
    </Paper>

		<Modal show={show} onHide={() => {
			setShow(false)
			TicketData()
			}} size='xl'>
				<Modal.Body className='p-0'>
					<TicketModal
						show={show}
						setShow={setShow}
						item={ticketData}
						ticketApi={TicketData}
					/>
				</Modal.Body>
			</Modal>
		</>
  );
};

export default Ticketing;

